import { ReactNode } from 'react';

import Tooltip from '@components/Tooltip';

interface PropTypes {
  title: string;
  content: ReactNode;
}

const Rodo = ({ title, content }: PropTypes) => {
  return (
    <Tooltip
      title={title}
      content={content}
      timeout={100}
      tooltipClassName="text-[#f08559] text-xs"
    ></Tooltip>
  );
};

export default Rodo;
